import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function DialogButtons({
  handleClose,
  onSubmit,
  buttonName,
  submittingText,
  closeOnSubmit = true,
}) {
  const [loading, setLoading] = useState(false);

  return (
    <React.Fragment>
      <Button
        disabled={loading ? true : false}
        onClick={async () => {
          setLoading(true);
          await onSubmit();
          setLoading(false);
          if (closeOnSubmit) handleClose();
        }}
        color="primary"
      >
        {loading ? <CircularProgress color="primary" size={40} /> : buttonName}
      </Button>
      {loading ? (
        <p>{submittingText}</p>
      ) : (
        <Button color="primary" autoFocus onClick={() => handleClose()}>
          Cancel
        </Button>
      )}
    </React.Fragment>
  );
}
